// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { UiPopover } from 'ui-components';

export const StyledRangePicker = styled('div')(
  () => css`
    &.range-picker {
      cursor: pointer;
      height: 46px;
      background: #ffffff;
      border: 1px solid #eeeeee;
      box-sizing: border-box;
      border-radius: 6px;
      padding: 12px 16px;
      justify-content: space-between;
      position: relative;
      min-width: 341px;
      .custom-range-input {
        padding: 10px 0;
        width: 281px;
        direction: rtl;
        text-align: right;
        border: none;
        white-space: nowrap;
        &:focus,
        &:hover,
        &:active {
          outline: none;
        }
      }
      .date-time {
        width: 100%;

        .rmdp-container {
          width: 100%;
        }

        cursor: pointer;
        .date {
          color: #333;
          margin-left: 10px;
        }
        .time {
          color: silver;
          margin: 0 5px;
        }
      }
    }
  `
);

export const StyledRangePickerPopover = styled(UiPopover)(
  () => css`
    .days-ago {
      display: flex;
      align-items: center;
      gap: 8px;
      .text {
        color: #222222 !important;
        font-size: 0.875rem !important;
        font-weight: 400;
      }

      & input {
        height: 36px !important;
        padding: 0px 10px !important;
        text-align: center !important;
      }
    }

    .teal {
      .time-durations {
        direction: rtl;
        margin: 0 auto;
        margin-top: 8px;
        gap: 7px;
        display: flex;
        width: 480px;
        flex-wrap: wrap;
        left: 0;
        button {
          width: 155px;
          &.MuiButton-outlinedDefault {
            border: 1px solid #f5f5f5;
            color: #454545;
            &:hover {
              background-color: rgba(34, 34, 34, 0.04);
            }
          }
        }
      }
      .icon {
        cursor: pointer;
        font-size: 1.25rem;
        // margin-right: -40px !important;
      }

      .jalali-date-picker-container {
        margin-top: 10px;
        margin-right: -15px;
      }
      .rmdp-today {
        .sd {
          color: #16898e !important;
          border: 1px solid #16898e !important;
          background-color: transparent !important;
        }
      }
      .rmdp-day span {
        font-size: 0.813rem !important;
      }
      .rmdp-range {
        background-color: #aadbdd !important;
        color: #16898e !important;
        box-shadow: none !important;
        &.start,
        &.end {
          // background-color: #4db6ac !important;
          // color: white !important;
          border-radius: 0 !important;
          border: 2px solid #16898e !important;
          box-sizing: border-box !important;
          border-radius: 4px !important;
        }
      }
      .rmdp-week-day {
        color: #6c879b !important;
      }
      .rmdp-day.rmdp-disabled {
        .highlight-red {
          opacity: 0.5 !important;
        }
      }
      .rmdp-range-picker-footer {
        .rmdp-header-values {
          span {
            color: #333333 !important;
            font-size: 0.75rem !important;
            font-weight: 400;
          }
          .rmdp-cancel {
            display: none;
          }
        }
      }
    }

    .range-picker-footer {
      background-color: #f7f8f9;
      color: #333333 !important;
      font-size: 0.75rem !important;
      font-weight: 400;
    }

    .rmdp-wrapper {
      cursor: default;
      justify-content: center;
      background: white !important;
      box-shadow: none !important;
      justify-self: center;
      .rmdp-calendar {
        border: none;
        &.rmdp-header {
          &.rmdp-header-values {
            background-color: #16898e;
            border: none;
          }
        }
      }
      .rmdp-top-class {
        justify-content: center;
        border: none !important;
      }
      .bottom {
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.12) !important;
        border-radius: 4px !important;
      }
      .time-picker {
        justify-content: space-between;
        color: #333333 !important;
        font-size: 0.75rem !important;
        font-weight: 400;

        .from-time-picker,
        .to-time-picker {
          flex: 1 1 !important;
          & input {
            height: 36px !important;
            padding: 0px 10px !important;
            color: #333333 !important;
            font-size: 0.875rem !important;
            font-weight: 400;
          }
        }
      }
    }

    @media screen and (max-width: 576px) {
      .teal {
        .rmdp-top-class {
          justify-content: center;
        }
        .time-picker {
          font-size: 0.75rem;
          padding-left: 12px !important;
          padding-right: 12px !important;
          .from-time-picker {
            margin-left: 50px;
          }
          .MuiTextField-root {
            max-width: 120px;
            .ri-time-line.icon {
              margin-right: 8px !important;
              padding: 0 !important;
            }
            input {
              padding-right: 8px;
            }
          }
        }
        .time-durations {
          width: 340px;
          margin: unset auto;
          margin-top: 16px;
          margin-bottom: 16px;
          justify-content: center;
          button {
            width: 104px;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 0.75rem !important;
          }
          button:nth-child(9),
          button:nth-child(8),
          button:nth-child(7) {
            display: none;
          }
        }
        .range-picker-footer {
          background-color: #f7f8f9;
          font-weight: 400;
          font-size: 0.75rem;
          text-align: start;
          min-width: 230px;
          button {
            margin-right: 8px;
          }
        }
      }
    }

    @media screen and (max-width: 360px) {
      .teal {
        .time-picker {
          .from-time-picker {
            margin-left: 12px;
          }
          .MuiTextField-root {
            width: 100px !important;
          }
        }
        .time-picker + hr {
          display: none;
        }
        .time-durations {
          display: none;
        }
        .range-picker-footer {
          min-width: 100px !important;
          & > div {
            max-width: 160px;
          }
        }
      }
    }

    @media screen and (max-width: 260px) {
      .teal {
        .time-picker {
          .from-time-picker {
            margin-left: 8px;
          }
          .MuiTextField-root {
            width: 90px !important;
          }
        }
        .time-picker + hr {
          display: none;
        }
        .time-durations {
          display: none;
        }
        .range-picker-footer {
          min-width: 100px !important;
          & > div {
            max-width: 120px;
          }
        }
      }
    }

    /*
     * With presets only there is nothing else in the popover, so the
     * duration buttons must stay visible and fit on very narrow screens.
     */
    @media screen and (max-width: 576px) {
      .teal.preset-durations .time-durations {
        display: flex;
        width: 100%;
        box-sizing: border-box;
        margin: 0;
        padding: 8px;
        justify-content: center;

        button {
          width: calc(50% - 4px);
        }
      }
    }
  `
);
